<div class="px-6 py-2 max-w-md mx-auto">

  <!-- Close Button -->
  <div class="flex justify-end mb-4">
    <button
      (click)="onClose()"
      class="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition"
      title="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Icon + Title -->
  <div class="flex flex-col items-center text-center mb-6">
    <div class="w-16 h-16 flex items-center justify-center rounded-full bg-primary/20 mb-3">
      <mat-icon class="text-primary text-4xl animate-pulse">
        local_taxi
      </mat-icon>
    </div>

    <h2 class="text-xl font-bold text-gray-800">
      {{ 'ACTIVE_TRIP.TITLE' | translate }}
    </h2>

    <p class="text-sm text-gray-500 mt-1">
      {{ 'ACTIVE_TRIP.DESCRIPTION' | translate }}
    </p>
  </div>

  <!-- Searching Indicator -->
  <div class="flex justify-center mb-6">
    <div class="flex items-center gap-2 px-4 py-2 rounded-full bg-blue-50 text-blue-600 text-sm font-semibold">
      <mat-icon *ngIf="isSearching" class="animate-spin">sync</mat-icon>
      <span>
        {{ getStatusMessage() | translate: getMessageParams() }}
        <span *ngIf="isSearching && offersCount > 0" class="ml-1">
          {{ 'ACTIVE_TRIP.CONTINUE_SEARCHING_MORE' | translate }}
        </span>
      </span>
    </div>
  </div>

  <!-- Route -->
  <div class="bg-white rounded-2xl shadow-md p-4 mb-6">

    <!-- Pickup -->
    <div class="flex gap-3 items-start">
      <mat-icon class="text-green-600">radio_button_checked</mat-icon>
      <div>
        <p class="text-xs text-gray-400">
          {{ 'LOCATION_PICKER.PICKUP' | translate }}
        </p>
        <p class="font-semibold text-gray-800">
          {{ data.ticket.initialAddress }}
        </p>
      </div>
    </div>

    <!-- Line -->
    <div class="ml-3 h-6 border-l-2 border-dashed border-gray-300 my-1"></div>

    <!-- Destination -->
    <div class="flex gap-3 items-start">
      <mat-icon class="text-red-600">location_on</mat-icon>
      <div>
        <p class="text-xs text-gray-400">
          {{ 'LOCATION_PICKER.DESTINATION' | translate }}
        </p>
        <p class="font-semibold text-gray-800">
          {{ data.ticket.destinationAddress }}
        </p>
      </div>
    </div>

  </div>


  <!-- Infos -->
  <div class="grid grid-cols-2 md:grid-cols-3 gap-3 mb-6 text-center">

    <div class="bg-gray-50 rounded-xl p-3">
      <mat-icon class="text-gray-500 mb-1">people</mat-icon>
      <p class="text-xs text-gray-400">
        {{ 'COMMON.PASSENGERS' | translate }}
      </p>
      <p class="font-semibold text-gray-800 text-sm">
        {{ data.ticket.passengers_nb }}
      </p>
    </div>

    <div class="bg-gray-50 rounded-xl p-3">
      <mat-icon class="text-gray-500 mb-1">work</mat-icon>
      <p class="text-xs text-gray-400">
        {{ 'COMMON.LUGGAGE' | translate }}
      </p>
      <p class="font-semibold text-gray-800 text-sm">
        {{ data.ticket.luggage_nb }}
      </p>
    </div>

    <div class="bg-gray-50 rounded-xl p-3 col-span-2 md:col-span-1">
      <mat-icon class="text-gray-500 mb-1">schedule</mat-icon>
      <p class="text-xs text-gray-400">
        {{ 'COMMON.DATE' | translate }}
      </p>
      <p class="font-semibold text-gray-800 text-sm">
        {{ data.ticket.scheduledDatetime | formatDate }}
      </p>
    </div>

  </div>

  <!-- Actions -->
  <div class="flex gap-3 w-full">
    <button
      (click)="onCancel()"
      class="flex-1 py-3 rounded-xl bg-gray-100 text-gray-700 font-semibold hover:bg-gray-200 transition">
      {{ 'ACTIVE_TRIP.CANCEL' | translate }}
    </button>

    <button
      (click)="onRightButtonClick()"
      class="flex-1 py-3 rounded-xl bg-primary text-black font-semibold hover:bg-primary-dark transition">
      {{ getRightButtonText() | translate }}
    </button>
  </div>
  </div>


